var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6624 4.4753C25.6624 4.4753 25.4106 2.71725 24.6349 1.93812C23.6578 0.919254 22.5598 0.919254 22.0461 0.85932C18.45 0.599609 13.0407 0.599609 13.0407 0.599609H13.0306C13.0306 0.599609 7.62133 0.599609 4.00506 0.85932C3.5014 0.919254 2.40343 0.919254 1.41626 1.93812C0.650695 2.71725 0.398865 4.4753 0.398865 4.4753C0.398865 4.4753 0.136963 6.55299 0.136963 8.62069V10.5585C0.136963 12.6262 0.398865 14.6939 0.398865 14.6939C0.398865 14.6939 0.650695 16.452 1.42633 17.2311C2.40343 18.25 3.69279 18.22 4.26696 18.3199C6.33196 18.5197 13.0306 18.5796 13.0306 18.5796C13.0306 18.5796 18.45 18.5696 22.0562 18.3099C22.5598 18.25 23.6578 18.25 24.645 17.2311C25.4206 16.452 25.6725 14.6939 25.6725 14.6939C25.6725 14.6939 25.9344 12.6262 25.9344 10.5585V8.62069C25.9243 6.55299 25.6624 4.4753 25.6624 4.4753ZM10.3713 12.9059V5.72391L17.3419 9.3299L10.3713 12.9059Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7974,
    height: 17.98,
    fill: "white",
    transform: "translate(0.136963 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.f55f8134260be5b007c4e7053ef9174e.svg";
export { ForwardRef as ReactComponent };